import React from 'react';
import { useSelector } from 'react-redux';
import assets from '../../imageAssets.json';
import Styles from './Loading.module.css';

export default function Loading() {
    const theme = useSelector(state => state.theme.mode);
    const logo = assets[theme === 'dark' ? 'logoWhite' : 'logoBlack'];
    return <div className={Styles.loading} role="status" aria-label="جاري التحميل">
        <div>
            <img src={logo.variants[0].url} width={logo.width} height={logo.height} alt="Loading" />
            <div className={Styles.track}><span /><span /></div>
        </div>
    </div>;
}
